import type { Domain } from "../../api/types";
import { Button } from "../../components/Button";
import { Modal } from "../../components/Modal";
import "../../components/Form.css";

interface DeleteDomainDialogProps {
  domain: Domain | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Domains are immutable once bound (ADR-0026 §3) — unbinding is the only
 * way to change one, which is why this is the only domain dialog besides
 * "bind." Unbinding only ever REDUCES what's exposed (no `service:update`
 * conjunction on delete, unlike create — see server's DeleteDomainHandler),
 * so the copy here doesn't need the same exposure warning bind gets. */
export function DeleteDomainDialog({ domain, isDeleting, onCancel, onConfirm }: DeleteDomainDialogProps) {
  return (
    <Modal open={domain !== null} title="Unbind domain" onClose={onCancel}>
      <p>
        Unbind <strong>{domain?.hostname}</strong>? This removes the binding only — it doesn't affect the running
        service.
      </p>
      <div className="form-actions">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button type="button" variant="danger" onClick={onConfirm} disabled={isDeleting}>
          {isDeleting ? "Unbinding…" : "Unbind"}
        </Button>
      </div>
    </Modal>
  );
}
